import React from 'react';
import CirclePhoto from "~/assets/circlePhoto.png";
import "./style.less";

export default function MainPage() {
	return <div className="mainPage">
		<h2 className="mainPage__place">SOBOTA – 28. KVĚTNA 2022</h2>
		<div>
			<img className="mainPage__circlePhoto" src={CirclePhoto} alt="Já s Léňou" />
		</div>
		<ul className="mainPage__list">
			<li className="mainPage__listItem"><a href="https://www.vinnysklepkrysa.cz/" target="_blank" rel="noreferrer">vinařství Krýsa</a>, Kostelec u Kyjova</li>
			<li className="mainPage__listItem">ubytování zajištěno</li>
			<li className="mainPage__listItem">parkování v areálu</li>
		</ul>
	</div>;
}
